<template>
  <a
    v-if="href"
    :href="href"
    :target="hrefExternal === true ? '_blank' : ''"
    :class="classes"
    :title="label"
    @click="handleButtonClick($event, variant)"
  >
    <span v-if="variant === 'xs'">
      <NbLoading v-if="loading" :is-small="true" />
      <NbIcon v-else-if="symbolLeft" :symbol="symbolLeft" :is-small="true" />
      <NbIcon v-else symbol="close" :is-small="true" />
    </span>
    <span v-else-if="variant === 'option'">
      <NbLoading v-if="loading" />
      <NbIcon v-else symbol="check" />
      <span>{{ label }}</span>
    </span>
    <NbLoading v-else-if="loading" />
    <span v-else-if="type === 'text'">
      <NbIcon v-if="symbolLeft" :symbol="symbolLeft" class="mr-2" />
      <span>{{ label }}</span>
      <NbIcon v-if="symbolRight" :symbol="symbolRight" class="ml-2" />
    </span>
    <span v-else>
      <NbIcon v-if="symbolLeft" :symbol="symbolLeft" />
      <NbIcon v-else symbol="close" />
    </span>
  </a>
  <button
    v-else
    type="button"
    :class="classes"
    :disabled="disabled"
    @click.prevent.capture="handleButtonClick($event, variant)"
  >
    <slot>
      <span v-if="variant === 'xs'">
        <NbLoading v-if="loading" :is-small="true" color="primary" />
        <NbIcon v-else-if="symbolLeft" :symbol="symbolLeft" :is-small="true" />
        <NbIcon v-else symbol="close" :is-small="true" />
      </span>
      <span v-else-if="variant === 'option'">
        <NbLoading v-if="loading" />
        <NbIcon v-else symbol="check" />
        <span>{{ label }}</span>
      </span>
      <NbLoading v-else-if="loading" />
      <span v-else-if="type === 'text'">
        <NbIcon v-if="symbolLeft" :symbol="symbolLeft" class="mr-2" />
        <span>{{ label }}</span>
        <NbIcon v-if="symbolRight" :symbol="symbolRight" class="ml-2" />
      </span>
      <span v-else>
        <NbIcon v-if="symbolLeft" :symbol="symbolLeft" />
        <NbIcon v-else symbol="close" />
      </span>
    </slot>
  </button>
</template>

<script setup lang="ts">
import '../scss/components/nb-button.scss'
import NbIcon from './NbIcon.vue'
import NbLoading from './NbLoading.vue'
import { computed } from 'vue'
import type { NbButtons } from './NbButtons'
const emit = defineEmits<{
  (e: 'click', ev: Event): void
}>()
const props = withDefaults(defineProps<NbButtons>(), {
  label: 'Action',
  variant: 'm',
  type: 'text',
  loading: false,
  disabled: false,
  inverted: false,
  selected: false,
  hrefExternal: false,
  color: 'primary'
})
const classes = computed(() => ({
  'nb-button': true,
  'nb-button-loading': props.loading,
  'nb-button-inverted': props.inverted && props.variant === 'm',
  'nb-button-option-selected': props.variant === 'option' && buttonSelected.value,
  [`nb-button-${props.variant}`]: props.variant !== 'm',
  [`nb-button-${props.type}`]: props.variant === 'm' && props.type !== 'text',
  [`nb-button-${props.color}`]: props.variant === 'm' || props.variant === 's'
}))
const handleButtonClick = (e: Event, variant: string) => {
  if (!props.href) {
    e.preventDefault()
    e.stopPropagation()
  }
  if (!props.disabled) {
    if (variant === 'option') {
      buttonSelected.value = !buttonSelected.value
    }
    emit('click', e)
  }
}
const buttonSelected = ref(props.selected)
</script>
